import { getCMSConfig } from '../cms';
import { NO_PATTERN_BUSINESS_LOGIC, Price } from '@vfde-brix/ws10/core';
import { JarvisProduct } from '@vfde-sails/avc-core';
import {
    IOfferSummaryCardAdditionalPrice,
    IOfferSummaryCardPromoPrice,
} from '@vfde-brix/ws10/offer-summary-card';
import { formatPriceLegalText } from '../formatter';
import { IHeadlineProperties } from '@vfde-brix/ws10/headline';
import { HomesPassedType } from '../../enums/product';

export const getPromoPricesProps = (
    product: JarvisProduct,
): Partial<IOfferSummaryCardPromoPrice>[] => {
    const promoPriceLines = [];

    const { monthly } = getCMSConfig().offerSummaryCard.priceText;
    const { discount, price } = product;

    // apply discount
    const isDiscount = 0 !== discount.gross;
    const priceNumber = isDiscount ? discount.gross : +price.monthly;

    promoPriceLines.push({
        containerPromoPrice: {
            price: Price.fromNumber(priceNumber),
            stdConditionAfter: monthly,
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        txtLabel: monthly,
    });

    return promoPriceLines;
};

export const getAdditionalPricesProps = (product: JarvisProduct): IOfferSummaryCardAdditionalPrice[] => {
    const additionalPrices = [];
    const { discount, price, provisionFee } = product;

    // Monthly price
    discount.month && additionalPrices.push({
        price: Price.fromNumber(+price.monthly),
        txtLabel: formatPriceLegalText(discount.month),
    });

    provisionFee && additionalPrices.push({
        price: Price.fromNumber(provisionFee.price),
        txtLabel: getCMSConfig().offerSummaryCard.priceText.connectionPrice,
    });

    return additionalPrices;
};

export const getHeadlineProps = (
    isPreFiber: boolean,
    isRegularFiber: boolean,
    tariffName?: string,
    homesPassedType?: HomesPassedType,
): Partial<IHeadlineProperties> => {
    const { homesPassedBHS, fiberAvailable, notAvailable } = getCMSConfig().offerSummaryCard;
    const updateProps: Partial<IHeadlineProperties> = {};

    if (homesPassedType === HomesPassedType.BHS) {
        updateProps.stdContent = homesPassedBHS.headline;
    } else if (isPreFiber) {
        updateProps.stdContent = tariffName;
    } else if (isRegularFiber) {
        updateProps.stdContent = fiberAvailable.headline;
    } else {
        updateProps.stdContent = notAvailable.headline;
    }

    return updateProps;
};
